import { render, staticRenderFns, recyclableRender, components } from "./storage-order-detail.vue?vue&type=template&id=0cfdaf74&scoped=true&"
var renderjs
import script from "./storage-order-detail.vue?vue&type=script&lang=js&"
export * from "./storage-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./storage-order-detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./storage-order-detail.vue?vue&type=style&index=1&id=0cfdaf74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfdaf74",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/storage-order-detail/storage-order-detail.vue"
export default component.exports